import wechat from './wechat'
import alipay from './alipay'
import baidu from './baidu'
import ByteDance from './bytedance';
import {
  config
} from "@/config/config";
let wxjssdkUrl = `${config.serverBaseUrl3}/union_applet/union_wechat_signature`;// 需要用到微信jssdk时的配置接口，不填就是用不到
let obj = {
  wechat,
  alipay,
  baidu,
  ByteDance
}
class SDK {
  constructor() {
    this.isLoad = false;
  }
  init(sdktype) {
    try {
      this.sdk = obj[sdktype || this.getEnv()];
      this.name = this.sdk.name;
      this.loadScript();
    } catch (err) {
      console.warn("当前环境本sdk没有检测到，请联系管理员");
    };
  }
  //获取当前环境
  getEnv() {
    let keyname = '';
    for (var item in obj) {
      if (obj[item].isme()) {
        keyname = item;
        break;
      }
    }
    //console.log("当前环境为" + keyname);
    return keyname;
  }
  noload() {} //还没加载好资源调用的方法回调
  loadScript() {
    this.loadScript = function () {
      //console.log("这是单例");
    }
    const el = document.createElement('script');
    el.src = this.sdk.scriptUrl;
    el.onload = () => {
      this.isLoad = true;
      console.log('sdk loaded!');
      this.noload(); //还没加载好资源调用的方法回调
      wxjssdkUrl && this.sdk === wechat && this.sdk.wxconfig(wxjssdkUrl);//是否需要在微信小程序webview里调用微信jssdk
    };
    document.body.appendChild(el);
  }
  navigateTo(src) {
    if (this.isLoad) {
      this.sdk.navigateTo(src);
    } else {
      this.noload = function () {
        this.sdk.navigateTo(src);
      }
    }
  }

  navigateBack(){
    if (this.isLoad) {
      this.sdk.navigateBack();
    } else {
      this.noload = function () {
        this.sdk.navigateBack();
      }
    }
  }

  reLaunchTo(src) {
    if (this.isLoad) {
      this.sdk.reLaunchTo(src);
    } else {
      this.noload = function () {
        this.sdk.reLaunchTo(src);
      }
    }
  }
  redirectTo(src) {
      if (this.isLoad) {
        this.sdk.redirectTo(src);
      } else {
        this.noload = function () {
          this.sdk.redirectTo(src);
        }
      }
  }

  //打电话
  makePhoneCall(tel) {
    if (this.isLoad) {
      this.sdk.makePhoneCall(tel);
    } else {
      this.noload = function () {
        this.sdk.makePhoneCall(tel);
      }
    }
  }
  //七鱼客服
  qiyu(){
    if (this.isLoad) {
      this.sdk.qiyu();
    } else {
      this.noload = function () {
        this.sdk.qiyu();
      }
    }
  }
  //跳转支付页面
  gopay(path,data) {
    if (this.isLoad) {
      this.sdk.gopay(path,data);
    } else {
      this.noload = function () {
        this.sdk.gopay(path,data);
      }
    }
  }
  //保存到手机相册
  savePhone(orderId,platform) {
    if (this.isLoad) {
      this.sdk.savePhone(orderId,platform);
    } else {
      this.noload = function () {
        this.sdk.savePhone(orderId,platform);
      }
    }
  }
  // ***************自定义方法***********************
    //微信拿相册并制成base54
    feedbackphotos() {
      if (this.isLoad) {
        return this.sdk.feedbackphotos();
      } else {
        this.noload = function () {
          return this.sdk.feedbackphotos();
        }
      }
    }
    //拿相册
    takephoto(platform,spec_id,openid) {
      if (this.isLoad) {
        return this.sdk.takephoto(platform,spec_id,openid);
      } else {
        this.noload = function () {
          return this.sdk.takephoto(platform,spec_id,openid);
        }
      }
    }
    //照相机
    takecamera(platform,spec_id,openid) {
      if (this.isLoad) {
        return this.sdk.takecamera(platform,spec_id,openid);
      } else {
        this.noload = function () {
          return this.sdk.takecamera(platform,spec_id,openid);
        }
      }
    }
    //微信看激励式广告
    lookAdvertise(page){
      if (this.isLoad) {
        return this.sdk.lookAdvertise(page);
      } else {
        this.noload = function () {
          return this.sdk.lookAdvertise(page);
        }
      }
    }
}

export default new SDK()